import React, {useEffect} from 'react';
import "./Notifications.css";
import {Notification, NotificationGroup} from '@progress/kendo-react-notification';
import {Fade} from "@progress/kendo-react-animation";
import {CLEAR_SUCCESS_NOTIFICATION, CLEAR_DELETE_NOTIFICATION} from "../../../redux/constants";
import {useTranslation} from "react-i18next";
import {connect} from 'react-redux';

const NOTIFICATION_FADE_TIME = 2 * 1000;

let SAVE_TIMER_ID = null;
let DELETE_TIMER_ID = null;

const Notifications = (props) => {

    useEffect(() => {
        if (!props.showSuccessNotification && SAVE_TIMER_ID !== null) {
            clearTimeout(SAVE_TIMER_ID);
            return;
        }

        SAVE_TIMER_ID = setTimeout(() => {
            props.clearSuccessNotification();
        }, NOTIFICATION_FADE_TIME);

    }, [props.showSuccessNotification]);

    useEffect(() => {
        if (!props.showDeleteNotification && DELETE_TIMER_ID !== null) {
            clearTimeout(DELETE_TIMER_ID);
            return;
        }

        SAVE_TIMER_ID = setTimeout(() => {
            props.clearDeleteNotification();
        }, NOTIFICATION_FADE_TIME);
    }, [props.showDeleteNotification]);

    const {t} = useTranslation();

    return (
        <React.Fragment>
            <Fade enter={true} exit={true}>
                {
                    props.showSuccessNotification &&
                    <NotificationGroup style={{ top: 0, left: '50%', transform: 'translateX(-50%)' }}>
                        <Notification
                            type={{
                                style: 'success',
                                icon: true
                            }}
                            closable={true}
                            onClose={props.clearSuccessNotification}
                            className="notification-bar"
                        >
                            <span className="title">{t('Global.save_success')}</span>
                        </Notification>
                    </NotificationGroup>
                }
            </Fade>
            <Fade enter={true} exit={true}>
                {
                    props.showDeleteNotification &&
                    <NotificationGroup style={{ top: 0, left: '50%', transform: 'translateX(-50%)' }}>
                        <Notification
                            type={{
                                style: 'error',
                                icon: true
                            }}
                            closable={true}
                            onClose={props.clearDeleteNotification}
                            className="notification-bar"
                        >
                            <span className="title">{t('Global.delete_success')}</span>
                        </Notification>
                    </NotificationGroup>
                }
            </Fade>

        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        showSuccessNotification: state.uxStateReducer.getIn(["notifications", "showSuccessNotification"]),
        showDeleteNotification: state.uxStateReducer.getIn(["notifications", "showDeleteNotification"])
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        clearSuccessNotification: () => dispatch({
            type: CLEAR_SUCCESS_NOTIFICATION
        }),
        clearDeleteNotification: () => dispatch({
            type: CLEAR_DELETE_NOTIFICATION
        })
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);

